// extracted by mini-css-extract-plugin
export default {"playerContainer":"VideoPlayer_playerContainer__Xl2sF","controls":"VideoPlayer_controls__EFSlK"};